import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { useParams } from "react-router-dom";

import React, { useEffect, useState } from "react";
import AdminOnly from "~/components/AdminOnly";
import EntityPlusForm from "./EntityPlusForm";
import useEntityPlusForm from "./useEntityPlusForm";
import { useSelector } from "react-redux";
import Notification from "../notification/Notification";
import CustomeButton from "../../Button/index";
import API_ROUTES from "../../../api-routes";
import AuditSidebar from "../../audit-sidebar/AuditSidebar";

const EntityPlus = () => {
  const { id } = useParams();

  const {
    isEdit,
    setIsEdit,
    handleEditClick,
    handleSaveClick,
    successMessage,
    setSuccessMessage,
    isLoading,
  } = useEntityPlusForm();
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [entityPlusData, setEntityPlusData] = useState({});
  const [tempData, setTempData] = useState({});
  const entityData = useSelector((state) => state.generalInformation);
  const [isAuditSidebarOpen, setIsAuditSidebarOpen] = useState(false);

  const handleDiscardClick = () => {
    setIsEdit(false);
    setEntityPlusData(tempData);
  };

  useEffect(() => {
    setEntityPlusData(entityData.generalInformation?.data.entityPlusConfigData);
    setTempData(entityData.generalInformation?.data.entityPlusConfigData);
  }, [entityData]);

  const handleFormStateChange = (isFormValid) => {
    setIsSaveDisabled(!isFormValid);
  };
  const auditLabels = () => {
    return {
      create: "Entity Added",
      update: "Entity Information Updated",
      delete: "Entity Removed",
    };
  };

  return (
    <>
      <Card className="gen-card h-full">
        <div className="entity-plus-container pb-4 flex justify-content-between formgrid grid grid-nogutter">
          <div>
            <p className="entity-plus">Entity Plus</p>
          </div>
          <AdminOnly>
            <div className="flex gap-3">
              {isEdit ? (
                <div className="flex gap-2">
                  <button
                    className="discard-button"
                    onClick={handleDiscardClick}
                  >
                    Discard
                  </button>
                  <Button
                    type="submit"
                    className={`add-btn  ${isSaveDisabled && "disable"}`}
                    disabled={isSaveDisabled}
                    onClick={() => handleSaveClick(entityPlusData)}
                    loading={isLoading}
                  >
                    {"Save Changes"}
                  </Button>
                </div>
              ) : (
                <>
                  <CustomeButton
                    label="View History"
                    variant="outlined"
                    className="mr-2"
                    icon="pi pi-history"
                    iconPos="right"
                    onClick={() => setIsAuditSidebarOpen(true)}
                  />

                  <button
                    className="edit-button"
                    onClick={() => {
                      handleEditClick();
                      setIsSaveDisabled(true);
                    }}
                  >
                    Edit
                    <span className="pi pi-pencil text-xs ml-2"></span>
                  </button>
                </>
              )}
            </div>
          </AdminOnly>

          <Notification
            successMessage={successMessage}
            setSuccessMessage={setSuccessMessage}
          />
        </div>
        {isAuditSidebarOpen && (
          <AuditSidebar
            heading="Entities Plus"
            endpoint={API_ROUTES.FETCH_ENTITY_PLUS_CONFIG_AUDIT}
            id={id}
            labels={auditLabels}
            setSidebarToggle={setIsAuditSidebarOpen}
            sidebarToggle={isAuditSidebarOpen}
          />
        )}
        <EntityPlusForm
          editMode={true}
          entityPlusData={entityPlusData}
          isEditing={isEdit}
          setIsSaveDisabled={setIsSaveDisabled}
          setEntityPlusData={setEntityPlusData}
          handleFormStateChange={handleFormStateChange}
        />
      </Card>
    </>
  );
};

export default EntityPlus;
